//电站列表
export const SET_FULL_SEARCH='header/global/SET_FULL_SEARCH';
//语言选择
export const SET_LOCALE='header/global/SET_LOCALE';
export const SET_MOBILE_MENU='header/global/set_mobile_menu';

